let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gaIvk")).then(() => parcelRequire('9HReW'));